import { render, staticRenderFns } from "./AssignedCustomers.vue?vue&type=template&id=1815292e&scoped=true"
import script from "./AssignedCustomers.vue?vue&type=script&lang=js"
export * from "./AssignedCustomers.vue?vue&type=script&lang=js"
import style0 from "./AssignedCustomers.vue?vue&type=style&index=0&id=1815292e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1815292e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1815292e')) {
      api.createRecord('1815292e', component.options)
    } else {
      api.reload('1815292e', component.options)
    }
    module.hot.accept("./AssignedCustomers.vue?vue&type=template&id=1815292e&scoped=true", function () {
      api.rerender('1815292e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/siteinfo/AssignedCustomers/AssignedCustomers.vue"
export default component.exports